import { Component } from '@angular/core';
import { NavController, ModalController, AlertController } from 'ionic-angular';
//import * as moment from 'moment';

import { VariablesProvider } from '../../providers/variables/variables';
import { FuncionesProvider } from '../../providers/funciones/funciones';
import { PicajesPage } from '../../pages/picajes/picajes';
import { TrabajadoresPage } from '../../pages/trabajadores/trabajadores';
import { CalendarioPage } from '../../pages/calendario/calendario';
import { MapasPage } from '../../pages/mapas/mapas';
import { VehiculosPage } from '../../pages/vehiculos/vehiculos';
import { LoginPage } from '../../pages/login/login';
import { ListPage } from '../../pages/list/list';
import { SalasPage } from '../../pages/salas/salas';
import { VacacionesPage } from '../../pages/vacaciones/vacaciones';
import { TictrabajadoresPage } from '../../pages/tictrabajadores/tictrabajadores';
import { AlbtrabajadoresPage } from '../../pages/albtrabajadores/albtrabajadores';
import { CalendarModal, CalendarModalOptions, DayConfig, CalendarResult } from "ion2-calendar";
import { CalendarComponentOptions } from 'ion2-calendar'
import { FormBuilder, FormGroup, Validators} from '@angular/forms';


@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})

export class HomePage {

  diasdefiesta;
  myForm: FormGroup;
  myForm1: FormGroup;
  misapp: Array<{title: string, descripcion: string, imagen: string , component: any}>;
  formulario = {codigo1: "",nombre1: "",horas1: "",horainicio1: "",activo1: ""}
  resultado;
  date: string;
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  minuto = []; //= {valor: "1",color: "1"}
  color = []; //= {valor: "1",color: "1"}
  cabecera = []; //= {valor: "1",color: "1"}
  trabajadores;
  pages22;
  valo="654321123456" ;
  formulario2 = {valor: ""}
  texto;

  constructor(
    public fb: FormBuilder,
    public modalCtrl: ModalController,
  	public navCtrl: NavController,
    public funciones:FuncionesProvider,
  	public variables:VariablesProvider
    ) {                    
           
      this.variables.btatras = true;
      var sum = 0;
      var horas=0;
      this.cabecera[0] = "s";

      this.pages22 = [];
      this.pages22.push ({ title: 'picajes', visible: this.variables.uservalor2.slice(0, 1)});
      this.pages22.push ({ title: 'Ticket', visible: this.variables.uservalor2.slice(1, 2)});  
      this.pages22.push ({ title: 'albaranes', visible: this.variables.uservalor2.slice(2, 3)});
      this.pages22.push ({ title: 'reservas', visible: this.variables.uservalor2.slice(3, 4)});
      this.pages22.push ({ title: 'vacaciones', visible: this.variables.uservalor2.slice(4, 5)});     


      

      this.myForm = this.fb.group({
      codigo: ['', [Validators.required]],
      nombre: ['', [Validators.required]],
      horas: ['', [Validators.required]],
      horainicio: ['', [Validators.required]],
      activo: ['', [Validators.required]]
    
     });

 this.myForm1 = this.fb.group({

      codigo1: ['', [Validators.required]],
      nombre1: ['', [Validators.required]],
      horas1: ['', [Validators.required]],
      horainicio1: ['', [Validators.required]],
      activo1: ['', [Validators.required]]
    
     });


 
   
   //if (this.variables.CONTROLACCESO != 11){

     this.obtenertrabajadores(this.valo);
   
   //}else{

   
   //}
    

  }


   buscartrabajadores(){
     var neutro;
    if (this.formulario2.valor != ""){
      neutro = this.formulario2.valor;
     }else{
      neutro = this.valo;
    }
    this.funciones.obtienetrabajadores(neutro).then(
          data => {
          this.trabajadores = data;
          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }

  obtenertrabajadores(filtro){

    this.funciones.obtienetrabajadores(filtro).then(
          data => {

          this.trabajadores = data;

         }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }





   openPicajes(codigotrabajador,nombretrabajador){

    this.variables.CODIGOTRABAJADOR = codigotrabajador;
    this.variables.NOMBRETRABAJADOR = nombretrabajador;
    
   
  
    this.navCtrl.push(PicajesPage);
  }
 openAlbTrabajadores(){
  
    this.navCtrl.push(AlbtrabajadoresPage);
  }

  openVacaciones(){
  
    this.navCtrl.push(VacacionesPage);
  }
openTicTrabajadores(){
  
    this.navCtrl.push(TictrabajadoresPage);
  }


  openReservar(){
    this.navCtrl.push(VehiculosPage);
  }
  opensalas(){
    this.navCtrl.push(SalasPage);
  }
 openHome(){
  
    this.navCtrl.push(ListPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts